import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { HtmlSnippet } from "./html-snippet";

import "./footer.module.css";

class FooterBase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monogramUrl: ""
    };
    this.footerElement = null;
  }

  componentDidMount() {
    this.initializeObserver();
  }

  componentDidUpdate(prevProp) {
    const prevMonogramUrl = get(prevProp, ["publisherTheme", "monogram"], "");
    const monogramUrl = get(this.props, ["publisherTheme", "monogram"], "");

    if (prevMonogramUrl !== monogramUrl) {
      this.setState({
        monogramUrl
      });
    }
  }

  initializeObserver() {
    this.footerLogoObserver = new IntersectionObserver((entries, observer) => this.setMonogramUrl(entries, observer), {
      rootMargin: "0px",
      threshold: 1.0
    });
    this.footerLogoObserver.observe(this.footerElement);
  }

  setMonogramUrl(entries, observer) {
    const entry = get(entries, [0], {});
    const monogramUrl = get(this.props, ["publisherTheme", "monogram"], "");
    entry.isIntersecting &&
      this.setState({ monogramUrl }, () => this.footerLogoObserver && this.footerLogoObserver.disconnect());
  }

  getImageTag() {
    if (!this.state.monogramUrl) {
      return <img styleName="logo" />;
    }
    return <img styleName="logo" src={this.state.monogramUrl} alt={this.props.publisherName} />;
  }

  render() {
    const copyrightText = get(this.props.publisherSettings, ["copyright"], "");
    const showFooterQuintypeLink = get(this.props.publisherTheme, ["footer-quintype-link"], "true") === "true";
    const bannerSource = get(this.props.publisherTheme, ["banner-source"], "");
    const footerMenu = this.props.menu.filter(item => item["menu-group-slug"] === "footer");
    const footerStyle = {
      color: this.props.publisherTheme.footer_text_color,
      backgroundColor: this.props.publisherTheme.footer_background_color
    };

    return (
      <div>
        {bannerSource && <HtmlSnippet bannerSource={bannerSource} />}
        <footer ref={el => (this.footerElement = el)} styleName="wrapper" data-testid="footer" style={footerStyle}>
          <div className="container" styleName="content">
            <div styleName="logo-wrapper">{this.getImageTag()}</div>
            <div styleName="menu-wrapper">
              {!footerMenu.length ? null : (
                <ul styleName="menu">
                  {footerMenu.map((item, index) => {
                    return (
                      <li key={index}>
                        <a href={item.completeUrl}>{item.title}</a>
                      </li>
                    );
                  })}
                </ul>
              )}
              <div styleName="copyright-text">{copyrightText}</div>
              {showFooterQuintypeLink && (
                <a
                  styleName="copyright-link"
                  href="https://www.quintype.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <strong>Powered by quintype</strong>
                </a>
              )}
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

FooterBase.propTypes = {
  publisherName: PropTypes.string,
  publisherSettings: PropTypes.shape({
    copyright: PropTypes.string
  }),
  publisherTheme: PropTypes.shape({
    footer_text_color: PropTypes.string,
    footer_background_color: PropTypes.string,
    "footer-quintype-link": PropTypes.string,
    "banner-source": PropTypes.string,
    monogram: PropTypes.string
  }),
  menu: PropTypes.array
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    publisherTheme: get(state, ["qt", "config", "theme-attributes"], {}),
    publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
    publisherName: get(state, ["qt", "config", "publisher-name"], "")
  };
}

export const Footer = connect(
  mapStateToProps,
  () => ({})
)(FooterBase);
